<script>
    const urlParams = new URLSearchParams(window.location.search);
    const visitedFromTTI = urlParams.has('tti');

</script>
<h1 class="title">
    Pricing
</h1>

<div class="columns is-multiline">
    <div class="column is-one-third is-full-touch">
        <div class="card">
            <header class="card-header">
                <p class="card-header-title">
                Free Plan
                </p>
                <button class="card-header-icon" aria-label="more options">
                <span class="icon has-text-grey-light">
                    <i class="fas fa-book" aria-hidden="true"></i>
                </span>
                </button>
            </header>
            <div class="card-content">
                <div class="content">
                    <p>Manage devices and users</p>
                    <p>Track and locate devices with geolocation and map services</p>
                    <p>Live tracking of mobile devices</p>
                    <p>Access device data using our API</p>
                </div>
            </div>
            <footer class="card-footer">
                <!-- svelte-ignore a11y-missing-attribute -->
                <div class="card-footer-item is-narrow is-size-7"><strong>30 days trial period</strong></div>
                <!-- svelte-ignore a11y-missing-attribute -->
                <div class="card-footer-item is-narrow is-size-7"></div>
                <a class="card-footer-item is-narrow is-size-7" href="mailto:support@tellsens.no">Contact us</a>
            </footer>
        </div>
    </div>
    <div class="column is-one-third is-full-touch">
        <div class="card">
            <header class="card-header">
                <p class="card-header-title">
                Basic Plan
                </p>
                <button class="card-header-icon" aria-label="more options">
                <span class="icon has-text-grey-light">
                    <i class="fas fa-book" aria-hidden="true"></i>
                </span>
                </button>
            </header>
            <div class="card-content">
                <div class="content">
                    <p>Manage devices and users</p>
                    <p>Track and locate devices with geolocation and map services</p>
                    <p>Live tracking of mobile devices</p>
                    <p>Access device data using our API</p>
                    <p><strong>Support by e-mail</strong></p>
                </div>
            </div>
            <footer class="card-footer">
                <!-- svelte-ignore a11y-missing-attribute -->
                <div class="card-footer-item is-narrow is-size-7"><strong>$ 3 month per device</strong></div>
                <!-- svelte-ignore a11y-missing-attribute -->
                <div class="card-footer-item is-narrow is-size-7"></div>
                <a class="card-footer-item is-narrow is-size-7" href="mailto:support@tellsens.no">Contact us</a>
            </footer>
        </div>
    </div>
    <div class="column is-one-third is-full-touch">
        <div class="card">
            <header class="card-header">
                <p class="card-header-title">
                Enterprise Plan
                </p>
                <button class="card-header-icon" aria-label="more options">
                <span class="icon has-text-grey-light">
                    <i class="fas fa-book" aria-hidden="true"></i>
                </span>
                </button>
            </header>
            <div class="card-content">
                <div class="content">
                    <p><i>For instances with more than 500 devices.</i></p>
                    <p>Manage devices and users</p>
                    <p>Track and locate devices with geolocation and map services</p>
                    <p>Live tracking of mobile devices</p>
                    <p>Access device data using our API</p>
                    <p>Support by e-mail</p>
                    <p><strong>Support by video meeting</strong></p>
                </div>
            </div>
            <footer class="card-footer">
                <!-- svelte-ignore a11y-missing-attribute -->
                <div class="card-footer-item is-narrow is-size-7"> </div>
                <!-- svelte-ignore a11y-missing-attribute -->
                <div class="card-footer-item is-narrow is-size-7"></div>
                <a class="card-footer-item is-narrow is-size-7" href="mailto:support@tellsens.no">Contact us</a>
            </footer>
        </div>
    </div>
    
</div> 

<style>
    .card-content {
        min-height: 80px;
    }
    .card-header-icon {
        cursor: default;
    }

</style>

